import React, { useState } from 'react';

interface HoverUnderlineSpanProps {
  onClick?: () => void;
  className?: string;
  children: React.ReactNode;
  title?: string;
}

export const HoverUnderlineSpan: React.FC<HoverUnderlineSpanProps> = ({
  onClick,
  className = '',
  children,
  title,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <span
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={hovered ? { color: 'var(--info-600)', textDecoration: 'underline', textUnderlineOffset: '2px' } : {}}
      className={`cursor-pointer transition-colors ${className}`}
      title={title}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      {children}
    </span>
  );
};
